angular.module('app')
  .factory('IllustrationResultsService', IllustrationResultsService);

/*@ngInject*/
function IllustrationResultsService($rootScope, $http, initData, SimpleSearchApiConfiguration, NoticeNavigationService) {
  var mosaic = typeof localStorage.illustrationsMosaic !== 'undefined' && JSON.parse(localStorage.illustrationsMosaic);
  var results = [];
  // En cas d'appel sans initData par IllustrationExpertSearchContainer
  if (initData.results) {
    results[0] = angular.copy(initData.results);
    storeContext();
  }
  var currentPage = 1;
  var totalResults = initData.totalResults;
  var moreResults = initData.hasMoreResults;
  var queryParams = initData.queryParams;

  $rootScope.$on('illustration-result-select', handleSelectedResult);
  $rootScope.$on('illustration-result-unselect', handleUnselectedResult);
  $rootScope.$on('illustration-results-select-all', handleAllSelectedResults);
  $rootScope.$on('illustration-results-unselect-all', handleAllUnselectedResults);

  $rootScope.$on('illustration-results-enable-mosaic', handleEnableMosaic);
  $rootScope.$on('illustration-results-disable-mosaic', handleDisableMosaic);

  $rootScope.$on('illustration-results-next', onSearchNextPage);
  $rootScope.$on('illustration-results-all', onSearchAll);

  return { getResults, getNumberDisplayedResults, getTotalResults, hasMoreResults, areAllSelected, isAtLeastOneSelected, isMosaicEnabled };

  function handleSelectedResult(event, resultId) {
    var result = _.find(_.flatten(results), { id: resultId });
    result.selected = true;

    $rootScope.$broadcast('illustration-results-changed');
  }

  function handleUnselectedResult(event, resultId) {
    var result = _.find(_.flatten(results), { id: resultId });
    result.selected = false;

    $rootScope.$broadcast('illustration-results-changed');
  }

  function handleAllSelectedResults(event) {
    _.flatten(results).forEach((result) => result.selected = true);

    $rootScope.$broadcast('illustration-results-changed');
  }

  function handleAllUnselectedResults(event) {
    _.flatten(results).forEach((result) => result.selected = false);

    $rootScope.$broadcast('illustration-results-changed');
  }

  function handleEnableMosaic(event) {
    mosaic = true;
    localStorage.illustrationsMosaic = JSON.stringify(mosaic);

    $rootScope.$broadcast('illustration-results-mosaic-changed');
  }

  function handleDisableMosaic(event) {
    mosaic = false;
    localStorage.illustrationsMosaic = JSON.stringify(mosaic);

    $rootScope.$broadcast('illustration-results-mosaic-changed');
  }

  function getNumberDisplayedResults() {
    return _.flatten(results).length;
  }

  function getTotalResults() {
    return totalResults;
  }

  function hasMoreResults() {
    return moreResults;
  }

  function getResults() {
    return _.flatten(_.cloneDeep(results));
  }

  function areAllSelected() {
    return _.every(_.flatten(_.cloneDeep(results)), 'selected');
  }

  function isAtLeastOneSelected() {
    return _.some(_.flatten(_.cloneDeep(results)), 'selected');
  }

  function isMosaicEnabled() {
    return mosaic;
  }

  function onSearchNextPage(event) {
    currentPage++;

    search(false);
  }

  function onSearchAll(event) {
    currentPage++;

    search(true);
  }

  function search(all) {
    var page = currentPage;

    $rootScope.$broadcast('illustration-search-loading');
    $http.get(SimpleSearchApiConfiguration.searchIllustrationUri,
      { params: _.merge({ page: page,
                          all: all }, queryParams) }
    ).then((response) => {
      results[page - 1] = response.data.results;
      totalResults = response.data.totalResults;
      moreResults = response.data.hasMoreResults;
      $rootScope.$broadcast('illustration-search-successful');
      storeContext();
      $rootScope.$broadcast('illustration-results-changed');
    }, () => {
      $rootScope.$broadcast('illustration-search-error');
    });
  }

  function storeContext() {
    let context = _.map(_.filter(_.flatten(results), r => !r.lot), r => {
      return {
        id: r.id,
        titre: r.titre,
        uri: r.uri
      }
    });
    NoticeNavigationService.setContext(context);
  }
}
